/**
 * HydroJug Signup Landing Page JavaScript
 * Handles Postscript SMS form submission with inline success message.
 */

(function() {
  'use strict';

  function initSignupForm() {
    var form = document.getElementById('hjslp-postscript-form');
    if (!form) return;

    form.addEventListener('submit', function() {
      setTimeout(function() {
        var formContainer = document.getElementById('hjslp-form-container');
        var successMessage = document.getElementById('hjslp-success-message');

        if (formContainer) formContainer.style.display = 'none';

        if (successMessage) {
          successMessage.style.display = 'block';
          successMessage.style.opacity = '0';
          requestAnimationFrame(function() {
            successMessage.style.transition = 'opacity 0.4s ease';
            successMessage.style.opacity = '1';
          });
        }
      }, 300);
    });
  }

  function init() {
    initSignupForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify theme editor support
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.classList.contains('section-hj-signup-lp-content')) {
        initSignupForm();
      }
    });
  }

})();
